export default [
  {
    key: 'basic',
    title: 'Basic task',
    value: `### Business Purpose
<!-- Describe the business need, the proposed solution, and expected benefit. -->
To [solve a specific business need or improve a process], [a solution or feature] should be introduced. This will [describe the benefits and positive impact].
---

### Requirements
<!-- List functional expectations in plain language. Include user flows, use cases, edge cases. Avoid technical implementation. -->
- 
- 
- 

---

### Technical Details (Dev)
<!-- Describe how it will be implemented. Include fields, API endpoints, logic, services, components, etc. -->
- 
- 
- 

---

### Acceptance Criteria
<!-- List everything that must be true for the task to be considered complete. -->
- [ ] List item 1
- [ ] List item 2
- [ ] List item 3

---

### Clarification Pending
<!-- Optional: List open questions that need PO/client input. -->
- 

---

### Estimate
<!-- Estimated time in hours (must be ≤ 8h). -->
\`x\` h
`,
  },
  {
    key: 'bug',
    title: 'Bug Fix',
    value: `### Overview
<!-- Concise summary of the issue -->

### Steps to Reproduce
1. 
2. 
3. 

---

### Expected vs Actual
**Expected:**  

**Actual:**  

---

### Context
<!-- Any relevant details: environment, device, browser, version -->
- environment
- browser
- device

---

### Acceptance Criteria
- [ ] Bug no longer reproducible
- [ ] QA verified

---

### Estimate
\`x\` h
`
  },
  {
    key: 'feature',
    title: 'Epic / Feature Request',
    value: `### Business Purpose
<!-- High-level summary of the feature or module -->
To [address a major need or opportunity], we want to [describe the functionality]. This will [benefit/impact].

---

### Scope
<!-- High-level description of what is in scope -->

---

### Out of Scope
<!-- Clarify what this epic won’t include -->

---

### Tasks to be created (titles only or links to tickets)
- [ ] Task 1
- [ ] Task 2
- [ ] Task 3

---

### Acceptance Criteria
- [ ] Feature delivers full value described above
- [ ] Tested and reviewed across all subtasks
- [ ] No critical bugs

---

### Estimation
<!-- Can be a rough range -->
\`5–15\` h (to be broken down in related tasks)

---
`
  },
  {
    key: 'research',
    title: 'Technical Research / Spike',
    value: `### Goal
<!-- Describe what you're researching -->
Understand/investigate [specific tech problem or choice] in order to [unblock/plan/decide something].

---

### Questions to Answer
- 
- 
- 

---

### Deliverables
- [ ] Summary of findings
- [ ] Suggested options
- [ ] Recommendation (+ reasoning)

---

### Context
<!-- Links, previous attempts, related tickets -->

---

### Estimate
\`x\` h (should not exceed 4h ideally)

---

`
  },
  {
    key: 'poc',
    title: 'POC / Prototype',
    value: `### Objective
<!-- Concise summary of the concept you're testing -->
<!-- Why this POC is needed -->
We want to validate whether [concept/tech approach] can be used to [achieve goal or solve problem]. This will help us decide if we should proceed with full implementation.

---

### Scope
<!-- What exactly will be done in this POC -->
<!-- Keep it limited — avoid extra features or polishing. -->
- 
- 
- 

---

### Constraints / Assumptions
<!-- What you're allowed to ignore or simplify -->
- No full validation, logging, or security
- Hardcoded values/mock data allowed
- Skipping error handling unless core to the concept

---

### Tools & Stack
<!-- What libraries, frameworks, or services will be used -->
- 
- 

---

### Deliverables
- [ ] Working demo or prototype
- [ ] Code in repo (link)
- [ ] Short summary of results + recommendation
- [ ] Short instruction on how to run it

---

### Estimate
\`x\` h (preferably < 4h–8h)
`
  }
]